import { EventDrivenStore } from '@core/store/eventDrivenStore';
import constants from '@core/utils/constants';

class Store extends EventDrivenStore {
  constructor() {
    const defaultState = {
      list_all: {
        list: [],
        error: null,
        loading: true
      },
      create_or_update: {
        loading: false,
        error: null
      }
    };

    super('admins', defaultState);
    this.defaultState = defaultState;
  }

  async setupEvents() {
    // List refresh events
    this.on(constants.EVENTS.ADMINS.LIST_ALL.REFRESHING, () => {
      this.state.list_all.loading = true;
      this.state.list_all.error = null;
    });

    this.on(constants.EVENTS.ADMINS.LIST_ALL.REFRESHED, (data) => {
      this.state.list_all.list = Array.isArray(data) ? data : [];
      this.state.list_all.loading = false;
      this.state.list_all.error = null;
    });

    this.on(constants.EVENTS.ADMINS.LIST_ALL.REFRESH_ERROR, (error) => {
      this.state.list_all.loading = false;
      this.state.list_all.error = error;
      this.state.list_all.list = [];
    });

    // Create/update events
    this.on(constants.EVENTS.ADMINS.CREATE_OR_UPDATE.CREATING, () => {
      this.state.create_or_update.loading = true;
      this.state.create_or_update.error = null;
    });

    this.on(constants.EVENTS.ADMINS.CREATE_OR_UPDATE.CREATED, () => {
      this.state.create_or_update.loading = false;
      this.state.create_or_update.error = null;
    });

    this.on(constants.EVENTS.ADMINS.CREATE_OR_UPDATE.CREATE_ERROR, (error) => {
      this.state.create_or_update.loading = false;
      this.state.create_or_update.error = error;
    });

    this.on(constants.EVENTS.ADMINS.CREATE_OR_UPDATE.UPDATING, () => {
      this.state.create_or_update.loading = true;
      this.state.create_or_update.error = null;
    });

    this.on(constants.EVENTS.ADMINS.CREATE_OR_UPDATE.UPDATED, () => {
      this.state.create_or_update.loading = false;
      this.state.create_or_update.error = null;
    });

    this.on(constants.EVENTS.ADMINS.CREATE_OR_UPDATE.UPDATE_ERROR, (error) => {
      this.state.create_or_update.loading = false;
      this.state.create_or_update.error = error;
    });
  }
}

export default Store;
